import $ from 'jquery';
import Swiper from 'swiper';
import inViewport from '../../../../drager/assets/scripts/util/in-viewport';

export default class Milestones {
  constructor() {
    this.$container = $('.milestones-container');
    this.mSwiper = false;
    this.modifyDOM();
    this.addEvents();
  }

  modifyDOM() {
    this.initSlider();
  }

  addEvents() {
    $(window).resize(() => {
      if (this.mSwiper.length) {
        const itemWidth = $('.milestones .swiper-slide:first-child').width();
        const padding = parseInt($('.milestones .swiper-full-container .row').css('padding-left'), 10);
        const containerOffset = ($('.milestones .container').width() / 2) - (itemWidth / 2) - padding - 25;
        this.mSwiper.params.slidesOffsetBefore = containerOffset * (-1);
        this.mSwiper.update();
      }
    });

    $(window).on('scroll', this.animateSection.bind(this));
  }

  animateSection() {
    if (this.$container.length && inViewport(this.$container[0], -150)) {
      this.$container.addClass('in-viewport');
    }
  }

  initSlider() {
    const itemWidth = $('.milestones .swiper-slide:first-child').width();
    const padding = parseInt($('.milestones .swiper-full-container .row').css('padding-left'), 10);
    const containerOffset = ($('.milestones .container').width() / 2) - (itemWidth / 2) - padding - 25;

    this.mSwiper = new Swiper('.milestones-container', {
      loop: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        renderFraction: (currentClass, totalClass) => `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`,
      },
      centeredSlides: true,
      slidesOffsetBefore: containerOffset * (-1),
      slidesPerView: 'auto',
    });
  }
}
